export default __webpack_public_path__ + "static/media/ic_dashboard.93d2c9e2.svg";